module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[85]572.4ca209b.woff2";